export default "__VITE_ASSET__BBbh9yK___"